// extracted by mini-css-extract-plugin
export default {"buttons":"DonationPlatformsSection_buttons__4-Abf","comment":"DonationPlatformsSection_comment__YvJ4c","container":"DonationPlatformsSection_container__ne7-H"};